import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import DrinkForm from './DrinkForm'
import { Edit } from 'react-admin'

const DrinEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <DrinkForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default DrinEdit
